module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAVCAYAAACQcBTNAAAA4klEQVQ4T5WTPQrCQBCF38R/CViJjdhoaSuCnQewtvQq25hsIoiksLOxjK1aKVh6iRReQhCREYWR+Jt16+/Nm3k7QzB4zEwj359SEhuGYeoQRTMQDX7CSqmsXSjMmbl/K/oVDoIgdzoeFwB64v4RVkoV7Xx+yUA33uYbrLUupYA1gM7rPE+w4zjljGWtALQ+Df6AJ8Nh5ZxOb8Dc/JbQHfY8r2ox7wDUf0VJY9dtXIi2AGpJmdNI6z2AdhJ4z/mvyn/1LPbGaYjAOGcRGP+gCIx3QwTGWxdzMNtnERhfigjkBq8PUFvqGaOnwQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/left_icon.png
// module id = 109
// module chunks = 28